import styled, { css } from 'styled-components'

export const AvatarWrapper = styled.div`
  margin-bottom: 10px;
`

export const RoleBadge = styled.span(
  ({ theme }) => css`
    margin-top: 4px;
    padding: 2px 8px;
    border-radius: ${theme.radii.rounded};
    background: ${theme.colors.background.tertiary.C};
    color: ${theme.colors.foreground.secondary.B};
    font-size: ${theme.fontSizes.C};
    font-weight: ${theme.fontWeights.medium};
  `
)
